import classnames from 'classnames'
import React, { useCallback } from 'react'
import { TAG_BACK } from '../analytics/analytics.tagids.constants'
import { navigateBack } from '../../store/history/history.actions'
import { withOnlyGE } from '../Device'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import SVGIcon from '../svg/SVGIcon'
import { useAction } from '../utils/react-redux'
import s from './ClosePopinButton.less'
import TagActionButton from './TagActionButton'
import cross from './assets/cross.svg'

const ClosePopinButton = ({ className, hasTag }) => {
  const execNavigateBack = useAction(navigateBack)
  const useNavigateBack = useCallback(() => execNavigateBack(), [])

  if (!hasTag)
    return (
      <div onClick={useNavigateBack}>
        <ClosePopinIcon className={className} />
      </div>
    )

  return (
    <TagActionButton type={TAG_BACK} deferClick onClick={useNavigateBack}>
      <ClosePopinIcon className={className} />
    </TagActionButton>
  )
}

const ClosePopinIcon = ({ className }) => (
  <div className={classnames(s.closeButton, className)}>
    <SVGIcon url={cross} />
  </div>
)

export const ClosePopinButtonGE = withOnlyGE(withEmptyFallbackErrorBoundary(ClosePopinButton))

export default withEmptyFallbackErrorBoundary(ClosePopinButton)
